<div class="container-fluid py-4">
  <div class="row justify-content-center mb-0">
    <div class="col column" *ngFor="let card of resumenCardsTwo; let i = index">
      <div
        class="card card-stats__two"
        [ngClass]="{ 'card-stats__two--selected': i === 1 }"
        [routerLink]="card.route"
        [style.cursor]="card.route ? 'pointer' : 'default'"
      >
        <div class="card-body">
          <div class="row">
            <div class="col-12 col-md-7 col-lg-6">
              <div
                class="icon-big text-center text-dark rounded shadow"
                [ngClass]="card.bgClass"
              >
                <i [class]="card.icon"></i>
              </div>
            </div>
            <div class="col-7 d-flex flex-column justify-content-center">
              <p class="card-category mb-0">{{ card.label }}</p>
              <h4 class="card-title mb-0" [ngClass]="{ 'text-dark': i === 1, 'text-white': i !== 0 }">{{ card.value }}</h4>
            </div>
          </div>
        </div>
        <div class="card-footer">
          <div class="stats">
            <small [class]="i == 1 ? 'desc__selected' : 'desc'">{{ card.desc }}</small>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row justify-content-center mb-0">
    <div class="col column" *ngFor="let card of resumenCards">
      <div class="card card-stats">
        <div class="card-body">
          <div class="row">
            <div class="col-7 col-md-7 col-lg-6">
              <div
                class="icon-big text-center text-dark rounded shadow"
                [ngClass]="card.bgClass"
              >
                <i [class]="card.icon"></i>
              </div>
            </div>
            <div class="col-5 d-flex flex-column justify-content-center">
              <p class="card-category mb-0">{{ card.label }}</p>
              <h4 class="card-title mb-0 text-white">{{ card.value }}</h4>
            </div>
          </div>
        </div>
        <div class="card-footer">
          <div class="stats">
            <small class="desc">{{ card.desc }}</small>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Campo de búsqueda mejorado con autocompletado -->
  <div class="row mb-3">
    <div class="col-md-4">
      <div class="input-group">
        <input
          type="text"
          class="form-control"
          placeholder="Buscar por nombre, apellido, teléfono, rol, estado o ciudad..."
          [(ngModel)]="searchText"
          (ngModelChange)="filtrarConductores()"
          list="sugerenciasConductores"
          autocomplete="off"
        />
        <span class="input-group-text bg-transparent"
          ><i class="fas fa-search text-dark"></i
        ></span>
        <datalist id="sugerenciasConductores">
          <option
            *ngFor="let sugerencia of sugerenciasBusqueda"
            [value]="sugerencia"
          ></option>
        </datalist>
      </div>
    </div>
  </div>

  <div class="card shadow-sm">
    <div class="card-body p-0">
      <div class="table-responsive">
        <table class="table table-bordered table-striped">
          <thead class="thead">
            <tr>
              <th>Profile</th>
              <th>Company</th>
              <th>City</th>
              <th>State</th>
              <th class="th__status">Status</th>
              <!--  <th>State</th>
                <th>City</th> -->
              <!-- <th class="th__phone">Email</th>
                <th class="th__phone">Phone</th> -->
              <!-- <th class="th__status">Actions</th> -->
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of filteredData">
              <td>
                <a [routerLink]="['/logistics/customers/edit', item._id]">
                  {{ item.firstname }} {{ item.lastname }}
                </a>
              </td>
              <td>{{ item.bussines_name }}</td>
              <td></td>
              <td></td>
              <td>
                <span
                  class="badge"
                  [ngClass]="item.status ? 'badge-success' : 'badge-danger'"
                >
                  {{ item.status ? "Active" : "Inactive" }}
                </span>
              </td>
              <!-- <td>{{ item.state }}</td>
                <td>{{ item.city }}</td> -->
              <!--  <td>{{ item.username }}</td>
                <td>{{ item.phone }}</td> -->
              <!-- <td>
                  <button
                    (click)="deleteData(item._id)"
                    class="btn btn-link text-dark btn-sm btn-del"
                  >
                    <i class="fas fa-trash"></i>
                  </button>
                </td> -->
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
